module.exports = __webpack_public_path__ + "img/shop7-4.69041c30.png";